<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Influenceurs
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Gestion des influenceurs</p>
  </div>

  <!-- Main card -->
  <div class="afri-card">

    <!-- Tabs -->
    <ul class="afri-tabs nav" style="padding: 0 1.5rem;">
      <li class="nav-item">
        <a role="tab" class="nav-link active" id="tab-c1-0" data-bs-toggle="tab" href="#tab-animated1-0" aria-selected="true">
          <span class="nav-text">Gestion des influenceurs</span>
        </a>
      </li>
      <li class="nav-item">
        <a role="tab" class="nav-link" id="tab-c1-1" data-bs-toggle="tab" href="#tab-animated1-1" aria-selected="false">
          <span class="nav-text">Gestion des codes des influenceurs</span>
        </a>
      </li>
    </ul>

    <div class="tab-content">

      <!-- Tab 1: Influenceurs -->
      <div class="tab-pane active" id="tab-animated1-0" role="tabpanel">

        <!-- Card header: actions + count -->
        <div class="afri-card-header">
          <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission">
            <button *ngIf="buttonsPermission.add" (click)="add(addContent)" class="btn-afri-primary">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              Ajouter
            </button>
            <button *ngIf="buttonsPermission.show" (click)="show(showContent)" class="btn-afri-outline">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
              </svg>
              Consulter
            </button>
            <button *ngIf="buttonsPermission.edit" (click)="edit(editContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
              </svg>
              Éditer
            </button>
            <button *ngIf="buttonsPermission.delete" (click)="delete()" class="btn-afri-danger">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
              Supprimer
            </button>
            <button *ngIf="buttonsPermission.edit" (click)="edit(addPromoContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
              </svg>
              Définir un code promo
            </button>
          </div>
          <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
            <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data!.length }}</span>
            élément(s)
            <app-loading [isVisible]="loading2"></app-loading>
          </div>
        </div>

        <!-- Table -->
        <div style="overflow-x: auto;">
          <table class="afri-table">
            <thead>
              <tr>
                <th style="width: 52px; padding-left: 1.5rem;">#</th>
                <th>Photo</th>
                <th>Nom</th>
                <th>Prénom(s)</th>
                <th>Email</th>
                <th>Téléphone</th>
                <th>Code</th>
                <th>Pays</th>
                <th>Ajouté par</th>
                <th>Modifié par</th>
                <th>Ajouté le</th>
                <th>Modifié le</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of data | paginate: {
                    id: 'ngxP1',
                    itemsPerPage: pg.pageSize,
                    currentPage: pg.p,
                    totalItems: pg.total
                  } | sampleSearch:search_text"
                  [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
                <td style="padding-left: 1.5rem;">
                  <input (click)="checked(d)" type="radio" name="selectRow"
                         style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
                </td>
                <td><img src="{{baseUrl}}/{{d.photo?.url}}" alt=""></td>
                <td>{{d.lastname}}</td>
                <td>{{d.firstname}}</td>
                <td>{{d.emailAddress}}</td>
                <td>{{d.phoneNumber}}</td>
                <td>{{d.reference}}</td>
                <td>{{d.country?.name}}</td>
                <td>{{d.creator?.lastname}} {{d.creator?.firstname}}</td>
                <td>{{d.updator?.lastname}} {{d.updator?.firstname}}</td>
                <td>{{d.created_at | date:"dd/MM/yyyy"}}</td>
                <td>{{d.updated_at | date:"dd/MM/yyyy"}}</td>
              </tr>

              <tr *ngIf="data.length === 0 && !loading2">
                <td colspan="12" style="padding: 4rem 1.25rem; text-align: center;">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                    <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div style="padding: 0.5rem 1.5rem 1.25rem;">
          <pagination-controls
            id="ngxP1"
            (pageChange)="getPage($event)"
            [maxSize]="9"
            [directionLinks]="true"
            [autoHide]="true"
            [responsive]="true"
            [previousLabel]="'Précédent'"
            [nextLabel]="'Suivant'">
          </pagination-controls>
        </div>

      </div><!-- end tab 1 -->

      <!-- Tab 2: Codes influenceurs -->
      <div class="tab-pane" id="tab-animated1-1" role="tabpanel">

        <!-- Card header: count -->
        <div class="afri-card-header">
          <div></div>
          <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
            <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data2!.length }}</span>
            élément(s)
            <app-loading [isVisible]="loading2"></app-loading>
          </div>
        </div>

        <!-- Table -->
        <div style="overflow-x: auto;">
          <table class="afri-table">
            <thead>
              <tr>
                <th style="width: 52px; padding-left: 1.5rem;">#</th>
                <th>Code</th>
                <th>Influenceur</th>
                <th>Description</th>
                <th>Remise</th>
                <th>Durée</th>
                <th>Utilisation</th>
                <th>Statut</th>
                <th>Ajouté par</th>
                <th>Modifié par</th>
                <th>Ajouté le</th>
                <th>Modifié le</th>
                <th>Expire le</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of data2 | paginate: {
                    id: 'ngxP2',
                    itemsPerPage: pg.pageSize,
                    currentPage: pg.p,
                    totalItems: pg.total
                  } | sampleSearch:search_text"
                  [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
                <td style="padding-left: 1.5rem;">
                  <input (click)="checked(d)" type="radio" name="selectRow"
                         style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
                </td>
                <td>{{d.code}}</td>
                <td>{{d.influencer?.lastname}} {{d.influencer?.firstname}}</td>
                <td>{{d.description}}</td>
                <td>{{d.discount}}</td>
                <td>{{d.duration}}</td>
                <td>{{d.status}}</td>
                <td>{{d.status}}</td>
                <td>{{d.creator?.lastname}} {{d.creator?.firstname}}</td>
                <td>{{d.updator?.lastname}} {{d.updator?.firstname}}</td>
                <td>{{d.created_at | date:"dd/MM/yyyy"}}</td>
                <td>{{d.updated_at | date:"dd/MM/yyyy"}}</td>
                <td>{{d.expires_at | date:"dd/MM/yyyy"}}</td>
              </tr>

              <tr *ngIf="data2.length === 0 && !loading2">
                <td colspan="13" style="padding: 4rem 1.25rem; text-align: center;">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                    <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div style="padding: 0.5rem 1.5rem 1.25rem;">
          <pagination-controls
            id="ngxP2"
            (pageChange)="getPage2($event)"
            [maxSize]="9"
            [directionLinks]="true"
            [autoHide]="true"
            [responsive]="true"
            [previousLabel]="'Précédent'"
            [nextLabel]="'Suivant'">
          </pagination-controls>
        </div>

      </div><!-- end tab 2 -->

    </div><!-- end tab-content -->

  </div><!-- end card -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
  <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Ajouter un Influenceur</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Référence <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="reference" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Nom <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="lastname" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Prénom <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="firstname" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Email <span class="text-danger ml-2">(*)</span></label>
          <input type="email" name="emailAddress" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Téléphone <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="phoneNumber" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Pays <span class="text-danger ml-2">(*)</span></label>
          <select name="country_id" class="afri-input" ngModel>
            <option *ngFor="let c of countries" [value]="c.id">{{c.name}}</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Photo <span class="text-danger ml-2">(*)</span></label>
          <input type="file" class="afri-input" (change)="upload($event)">
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="addForm.invalid">Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #editContent let-c="close" let-d="dismiss">
  <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Modifier un Influenceur</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Référence <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="reference" class="afri-input" [(ngModel)]="selected_data.reference">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Nom <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="lastname" class="afri-input" [(ngModel)]="selected_data.lastname">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Prénom <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="firstname" class="afri-input" [(ngModel)]="selected_data.firstname">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Email <span class="text-danger ml-2">(*)</span></label>
          <input type="email" name="emailAddress" class="afri-input" [(ngModel)]="selected_data.emailAddress">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Téléphone <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="phoneNumber" class="afri-input" [(ngModel)]="selected_data.phoneNumber">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Pays <span class="text-danger ml-2">(*)</span></label>
          <select name="country_id" class="afri-input" [(ngModel)]="selected_data.country_id">
            <option *ngFor="let c of countries" [value]="c.id">{{c.name}}</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Photo <span class="text-danger ml-2">(*)</span></label>
          <input type="file" class="afri-input" (change)="upload($event)">
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="editForm.invalid">Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #addPromoContent let-c="close" let-d="dismiss">
  <form #editForm="ngForm" (ngSubmit)="addPromo(editForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Ajouter un code PROMO</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Code promo <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="code" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Description <span class="text-danger ml-2">(*)</span></label>
          <textarea name="description" class="afri-input" ngModel></textarea>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Pourcentage de la remise (en %) <span class="text-danger ml-2">(*)</span></label>
          <input type="number" name="discount" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Durée de validité de ce code (en jours) <span class="text-danger ml-2">(*)</span></label>
          <input type="number" name="duration" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Date de début de validité <span class="text-danger ml-2">(*)</span></label>
          <input type="datetime-local" name="starts_at" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Code du pays <span class="text-danger ml-2">(*)</span></label>
          <select name="country_id" class="afri-input" ngModel>
            <option *ngFor="let c of countries" [value]="c.id">{{c.name}}</option>
          </select>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="editForm.invalid">Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #showContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive table-card">
      <table class="table table-borderless align-middle mb-0">
        <tbody></tbody>
      </table>
    </div>
  </div>
</ng-template>
